import React, { useState, useEffect, useContext } from "react";
import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import { signOut } from "../../../common/signout/signout";
import { Context } from "../../../common/context/Context";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { clearAuthData } from "../../hooksAndFunctions/functions/clearAuthData";
import { useGetLoggedInUserDetails } from "../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";

const drawerWidth = 250;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    backgroundColor: '#fff',
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const MainAppbar = ({ openSidebar, setOpenSidebar }) => {
    const context = useContext(Context);

    /**Menu states in Appbar e.g. profile avtar */
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const { loggedInUser } = useGetLoggedInUserDetails()

    const [userInitials, setUserInitials] = useState('')
    const [fullName, setFullName] = useState('')

    useEffect(() => {
        if (!!Object.keys(loggedInUser).length) {
            const lNameInitial = loggedInUser?.firstName.substring(0, 1).toUpperCase();
            const fNameInitial = loggedInUser?.lastName.substring(0, 1).toUpperCase();

            setUserInitials(`${fNameInitial}${lNameInitial}`)
            setFullName(`${loggedInUser?.firstName} ${loggedInUser?.lastName}`)
        }
    }, [loggedInUser])

    return (
        <AppBar position="absolute" open={openSidebar}>
            <Toolbar
                sx={{
                    pr: '24px', // keep right padding when drawer closed
                }}
            >
                <IconButton
                    edge="start"
                    color="gray"
                    aria-label="open drawer"
                    onClick={() => { setOpenSidebar(!openSidebar) }}
                    sx={{
                        marginRight: '36px',
                        ...(openSidebar && { display: 'none' }),
                    }}
                    disabled={!!context?.isUserActive ? false : true}
                >
                    <MenuIcon />
                </IconButton>

                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                >

                    {/**notification bell*/}
                    {/* <IconButton color="inherit">
                                <Badge badgeContent={4} color="secondary">
                                    <NotificationsIcon />
                                </Badge>
                            </IconButton> */}

                    {/** profile avatar*/}
                    <div>
                        {/* <AccountCircle /> */}
                        <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={1}
                        >
                            <Typography
                                variant="body1"
                                align="center"
                                sx={{ color: '#293042' }}
                            >
                                {!!fullName ? fullName : ""}
                            </Typography>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                            >
                                <Avatar>{userInitials}</Avatar>
                            </IconButton>

                        </Stack>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleClose}>Profile</MenuItem>
                            <MenuItem
                                onClick={() => {
                                    handleClose();
                                    signOut();
                                    clearAuthData()
                                }}
                            >Sign out</MenuItem>
                        </Menu>
                    </div>
                </Grid>
            </Toolbar>
        </AppBar>
    )
}
export default MainAppbar